module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/babel-loader/lib/index.js??clonedRuleSet-9[0].rules[0]!./Map.js"));
	}, "map");
}